module.exports = __webpack_public_path__ + "f5080ea9cccdd72a62241b2410f1b773.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/media/fonts/Poppins/Poppins-ExtraLightItalic.ttf
// module id = 1255
// module chunks = 0